import PropTypes from 'prop-types';
import React from 'react';
import formatTimeString from '../../utils/formatTimeString';
import {
  packageInitialPrice,
  packagePrice,
  packagePricePreTax
} from '../../utils/packagePrice';
import Price from '../common/Price';
import PriceSum from '../common/PriceSum';

export const PackageAddOnsReview = ({
  pkg,
  num,
  value,
  addOns = [],
  sale,
  salePkg,
  config
}) => {
  const selectedAddOns = addOns.filter(addOn => value[addOn.item_id]);

  return (
    <div className="swformfield-tktpackage-lineitem">
      <div className="swformfield-tktpackage-lineitem__summary">
        <div className="swformfield-tktpackage-lineitem__summary-header">
          {pkg.descrip}
          {sale && salePkg && salePkg.time && (
            <span>
              &nbsp;@&nbsp;
              {formatTimeString(sale.day, salePkg.time)}
            </span>
          )}
          <span className="swformfield-tktpackage-lineitem__summary-header-quantity">
            &nbsp;({num})
          </span>
        </div>
        <div className="swformfield-swformfield-tktpackage-lineitem__amount-total">
          {config.taxInclusive ? (
            <PriceSum
              price={packagePrice(pkg, sale)}
              count={num}
              initialPrice={packageInitialPrice(pkg)}
            />
          ) : (
            <PriceSum
              price={packagePricePreTax(pkg, sale)}
              count={num}
              initialPrice={packageInitialPrice(pkg)}
            />
          )}
        </div>
      </div>

      <div className="swformfield-tktpackage-lineitem__addons-list">
        {selectedAddOns == null || selectedAddOns.length < 1 ? (
          <div className="swformfield-tktpackage-lineitem__addon-summary swformfield-tktpackage-lineitem__addon-summary--empty"></div>
        ) : (
          selectedAddOns.map(addOn => {
            return (
              <div
                key={addOn.item_id}
                className="swformfield-tktpackage-lineitem__addon-summary"
              >
                <div className="swformfield-tktpackage-lineitem__addon--name">
                  {addOn.descrip}
                  {value[addOn.item_id].time && (
                    <span>
                      &nbsp;@&nbsp;
                      {formatTimeString(sale.day, value[addOn.item_id].time)}
                    </span>
                  )}
                </div>
                <div className="swformfield-tktpackage-lineitem__addon--quantity">
                  {value[addOn.item_id].qty || value[addOn.item_id]}
                </div>
                <div className="swformfield-tktpackage-lineitem__addon--total">
                  {config.taxInclusive ? (
                    <Price
                      price={packagePrice(addOn, sale)}
                      initialPrice={packageInitialPrice(addOn)}
                    />
                  ) : (
                    <Price
                      price={packagePricePreTax(addOn, sale)}
                      initialPrice={packageInitialPrice(addOn)}
                    />
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

PackageAddOnsReview.propTypes = {
  pkg: PropTypes.object,
  num: PropTypes.number,
  addOns: PropTypes.array,
  value: PropTypes.object,
  sale: PropTypes.object,
  salePkg: PropTypes.object,
  config: PropTypes.object
};
